import {
    WithdrawalUnfinishedTransactionRowStyled,
    WithdrawalUnfinishedTransactionStyled
} from "./styled/WithdrawalUnfinishedTransactionStyled";
import { useDispatch, useSelector } from "react-redux";
import { getWaitingWithdrawal } from "../../../../app/appSelectors";
import { useCallback, useState } from "react";
import WithdrawalUnfinishedTransactionItem from "./WithdrawalUnfinishedTransactionItem";
import {
    MOBILE_SLIDER_PAGES_IDS
} from "../../../../mobileAppCore/components/MobileSliderPages/mobileSliderPagesConstants";
import { locationSlice } from '../../../Location/locationReducer';

export default function WithdrawalUnfinishedTransaction() {
    const waitingWithdrawal = useSelector(getWaitingWithdrawal);
    const [showAll, setShowAll] = useState(false);
    const dispatch = useDispatch();

    const showAllClickHandler = useCallback(() => {
        setShowAll(true);
    }, []);

    const onCancelClickHandler = useCallback((e) => {
        e.stopPropagation();
        const uuid = e.currentTarget.dataset.uuid;
        if (uuid) {
            dispatch(locationSlice.actions.openLocationAction({
                name: MOBILE_SLIDER_PAGES_IDS.WITHDRAWAL_CANCEL,
                searchParams: { uuid }
            }));
        }
    }, [dispatch]);

    if (!waitingWithdrawal?.length) {
        return null;
    }

    return <WithdrawalUnfinishedTransactionStyled show={true}>
        {
            !showAll ? <WithdrawalUnfinishedTransactionRowStyled
                onClick={showAllClickHandler}
                stacked={!showAll && waitingWithdrawal.length > 1}
            >
                <WithdrawalUnfinishedTransactionItem item={waitingWithdrawal[0]}
                                                     onCancelClick={onCancelClickHandler}/>
            </WithdrawalUnfinishedTransactionRowStyled> : <>
                {
                    waitingWithdrawal.map((item, index) => {
                        return <WithdrawalUnfinishedTransactionRowStyled key={index}>
                            <WithdrawalUnfinishedTransactionItem item={item}
                                                                 onCancelClick={onCancelClickHandler}/>
                        </WithdrawalUnfinishedTransactionRowStyled>
                    })
                }
            </>
        }
    </WithdrawalUnfinishedTransactionStyled>
}
